import { render, staticRenderFns } from "./editOrderMan.vue?vue&type=template&id=453c6e68&scoped=true&"
import script from "./editOrderMan.vue?vue&type=script&lang=js&"
export * from "./editOrderMan.vue?vue&type=script&lang=js&"
import style0 from "./editOrderMan.vue?vue&type=style&index=0&id=453c6e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c6e68",
  null
  
)

export default component.exports